__turbopack_context__.v({
  "button": "MyNaviVerticalNavigation-module__Lb1C9q__button",
});
